/**
 * Event Tracking Utilities
 *
 * Centralized event tracking for analytics and user behavior monitoring
 */

import { timeCapsuleApi } from '../services/apiService';

export interface UserMetadata {
    nationality: string;
    language: string;
    ageGroup: string;
}

export interface TrackingEvent {
    userMetadata: UserMetadata;
    zone: string;
    metadata: unknown;
    timestamp?: string;
}

/**
 * Track a user event
 */
export async function trackEvent(eventType: string, event: TrackingEvent): Promise<void> {
    try {
        await timeCapsuleApi.trackEvent(eventType, event);
    } catch (error) {
        console.warn('Failed to track event:', eventType, error);
    }
}

/**
 * Track QR code scans
 */
export async function trackRegistration(hasConsent: boolean, hasSelfie: boolean, userMetadata: UserMetadata, timestamp?: string): Promise<void> {
    return trackEvent('registration', {
        userMetadata,
        zone: '1.0',
        metadata: {
            hasConsent,
            hasSelfie,
        },
        timestamp,
    });
}


/**
 * Track QR code scans
 */
export async function trackQRScan(zone: string, userMetadata: UserMetadata, metadata: Record<string, unknown>, timestamp?: string,): Promise<void> {
    return trackEvent('qr_scan',
        {
            userMetadata,
            zone,
            timestamp,
            metadata,
        }
    );
}


/**
 * Get visitor ID from localStorage or Redux store
 */
function getVisitorIdFromStorage(): string | null {
    try {
        // Try to get from Redux store first (if available)
        const persistedState = localStorage.getItem('persist:user');
        if (persistedState) {
            const parsedState = JSON.parse(persistedState);
            const userState = JSON.parse(parsedState.user || '{}');
            if (userState.visitorId) {
                return userState.visitorId;
            }
        }
        return null;
    } catch (error) {
        console.warn('Failed to get visitor ID from storage:', error);
        return null;
    }
}
